module.exports = __webpack_public_path__ + "img/pla_YFW.eb0124e9.png";